import React from 'react';

import { Link } from 'react-router-dom';
import RootErrorPage from '../components/Error/RootErrorPage';
import { DEFAULT_PAGE_TITLE } from '@/core/utils/app.constants';
import { ROUTE_NAMES } from '@/core/routes/routeNames';
import Button from '@/components/Button/Button';
import coreTokens from '@/core/tokens.json';

function NotFoundErrorPage() {
  const pageTitle = `${coreTokens['404']} | ${DEFAULT_PAGE_TITLE}`;

  const CTA = () => {
    return (
      <Button
        component={Link}
        to={ROUTE_NAMES.ROOT}
        variant="contained"
        aria-label={coreTokens['NAVIGATE_HOME']}
      >
        {coreTokens.HOME}
      </Button>
    );
  };
  return (
    <RootErrorPage
      pageTitle={pageTitle}
      title={coreTokens['404']}
      description={coreTokens.NOT_FOUND}
      cta={<CTA />}
    />
  );
}

export default NotFoundErrorPage;
